import { FC } from "react";
import clsx from "clsx";

export const SkeletonBlock: FC<{ className?: string }> = ({ className }) => (
  <div className={clsx("animate-pulse rounded-md bg-background-subtle", className)} />
);

const CARD_CLASS = "bg-background-default flex w-full flex-col gap-4 rounded-sm p-5 shadow-sm";

export const BookingSummarySkeleton = () => (
  <div className={CARD_CLASS}>
    <div className="flex items-center justify-between gap-3">
      <SkeletonBlock className="h-6 w-32" />
      <SkeletonBlock className="h-7 w-20 rounded-full" />
    </div>
    <div className="flex flex-col gap-2">
      <SkeletonBlock className="h-3 w-16" />
      <SkeletonBlock className="h-9 w-64 max-w-full" />
    </div>
    <SkeletonBlock className="h-px w-full" />
    <div className="flex flex-wrap gap-5">
      <div className="flex flex-col gap-2">
        <SkeletonBlock className="h-3 w-20" />
        <SkeletonBlock className="h-5 w-36" />
      </div>
      <div className="flex flex-col gap-2">
        <SkeletonBlock className="h-3 w-12" />
        <SkeletonBlock className="h-5 w-16" />
      </div>
    </div>
  </div>
);

export const FlightDetailsSkeleton = () => (
  <div className={CARD_CLASS}>
    <SkeletonBlock className="h-6 w-32" />
    <div className="border-border-default flex flex-col gap-4 rounded-xl border p-4">
      <div className="flex items-center gap-3">
        <SkeletonBlock className="size-10 rounded-lg" />
        <SkeletonBlock className="h-4 w-32" />
      </div>
      <div className="flex items-center justify-between gap-4">
        <div className="flex flex-col gap-2">
          <SkeletonBlock className="h-6 w-14" />
          <SkeletonBlock className="h-4 w-16" />
          <SkeletonBlock className="h-3 w-24" />
        </div>
        <SkeletonBlock className="h-0.5 flex-1" />
        <div className="flex flex-col items-end gap-2">
          <SkeletonBlock className="h-6 w-14" />
          <SkeletonBlock className="h-4 w-16" />
          <SkeletonBlock className="h-3 w-24" />
        </div>
      </div>
      <SkeletonBlock className="h-px w-full" />
      <div className="flex gap-3">
        <SkeletonBlock className="h-8 w-28 rounded-full" />
        <SkeletonBlock className="h-8 w-24 rounded-full" />
      </div>
    </div>
  </div>
);

export const PassengersSkeleton = () => (
  <div className="flex flex-col gap-3">
    <SkeletonBlock className="h-6 w-40" />
    <div className="bg-background-default outline-border-subtle flex overflow-hidden rounded-xl outline">
      <SkeletonBlock className="w-16 shrink-0 rounded-none md:w-24" />
      <div className="flex flex-1 flex-wrap items-center justify-between gap-4 p-4">
        <div className="flex flex-col gap-2">
          <SkeletonBlock className="h-3 w-24" />
          <SkeletonBlock className="h-6 w-48" />
        </div>
        <div className="flex gap-8">
          <div className="flex flex-col gap-2">
            <SkeletonBlock className="h-3 w-10" />
            <SkeletonBlock className="h-5 w-14" />
          </div>
          <div className="flex flex-col gap-2">
            <SkeletonBlock className="h-3 w-16" />
            <SkeletonBlock className="h-5 w-20" />
          </div>
        </div>
      </div>
    </div>
  </div>
);
